import { sprinkles, Sprinkles } from '@design-system/sprinkles.css';
import { ReactComponent as LogoGlyphSvg } from './playbook_logo_glyph.svg';
import { ReactComponent as LogoNameSvg } from './playbook_logo_name.svg';
import { clsx } from 'clsx';

type PlaybookLogoProps = {
  showName?: boolean;
  showGlyph?: boolean;
  className?: string;
  height?: number;
} & Pick<Sprinkles, 'color'>;

export const PlaybookLogo = (p: PlaybookLogoProps) => {
  const glyphHeight = p.height ?? 18;
  const nameHeight = glyphHeight * 0.67;
  const gap = glyphHeight * 0.75;

  return (
    <div
      className={clsx(
        sprinkles({
          display: 'flex',
          alignItems: 'center',
          color: p.color,
        }),
        p.className,
      )}
      style={{ gap: gap + 'px' }}
    >
      {p.showGlyph && <LogoGlyphSvg height={glyphHeight} />}
      {p.showName && <LogoNameSvg height={nameHeight} />}
    </div>
  );
};
